import type {ReposListResults} from '@github-ui/repos-list'

import {useReposFinderStateContext} from '../contexts/ReposFinderStateContext'
import type {PagePayload} from '../types'

/**
 * Hook to manage the state of the repos finder page results.
 * Handles the display logic for showing empty results when the query is cleared.
 *
 * @param payload - The page payload containing repository search results
 */
export function useReposFinderState(payload: PagePayload) {
  const {fetchedQuery, currentPage, fetchResults} = useReposFinderStateContext()

  // When fetchedQuery is empty, the user has explicitly cleared the filter
  // In this case, show empty results to trigger the "Enter a query" message
  const emptyResults: ReposListResults = {repositories: [], repositoryCount: 0, pageCount: 1}
  const hasQuery = !!fetchedQuery
  const results = hasQuery ? payload : emptyResults

  return {
    fetchedQuery,
    results,
    currentPage,
    fetchResults,
  }
}
